<template>
    <section>
        <div class="row">
            <div class="col-md-4 col-sm-6 col-xs-12">
                <div v-if="empresa.plano" class="info-box"
                    :class="{'bg-green': empresa.plano.recorrente, 'bg-red': !empresa.plano.recorrente}">
                    <span class="info-box-icon"><i class="fa"
                            :class="{'fa-thumbs-up': empresa.plano.recorrente, 'fa-thumbs-down': !empresa.plano.recorrente}"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text text-uppercase" v-if="empresa.plano.config" >{{empresa.plano.config.nome}}</span>
                        <span class="info-box-number">Vencimento em
                            {{formatDate(empresa.plano.vencimento_padrao)}}</span>
                        <div class="progress">
                            <div class="progress-bar" :style="`width: ${empresa.plano.percentage}%`"></div>
                        </div>
                        <span class="progress-description">
                            <span v-if="!empresa.plano.recorrente">Seu plano vence em <strong>{{empresa.plano.restante}}</strong> dias</span>
                            <span v-else>Seu plano renova em <strong>{{empresa.plano.restante}}</strong> dias</span>
                        </span>
                    </div>
                </div>
                <div v-else class="info-box bg-red">
                    <span class="info-box-icon"><i class="fa fa-times"></i></span>
                    <div class="info-box-content">
                        <span class="info-box-text">Nenhum Plano Configurado</span>
                        <div class="progress">
                            <div class="progress-bar" style="width: 0%"></div>
                        </div>
                    </div>
                </div>

                <p-check v-if="empresa.plano" disabled :color="appLayout.switch" :checked="empresa.plano.recorrente"
                    class="p-switch p-fill">Renovação automática da assinatura</p-check>
            </div>
            <div class="col-md-offset-2 col-md-6 col-sm-6 col-xs-12">
                <div>
                    <h4> Para alteração do plano, entre em contato com o suporte.</h4>
                    <p>Telefone: (12) 3152-9360 e (12) 9 7404-9319 <i class="text-green fa fa-whatsapp"></i></p>
                    <p>E-mail: suporte@mbd.com.br</p>
                    <p><i class="text-blue fa fa-skype"></i> Skype: suporte@mbd.com.br, suporte1@mbd.com.br,
                        suporte2@mbd.com.br e suporte3@mbd.com.br</p>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
    export default {
        props: {
            empresa: {}
        },
       
        beforeMount() {
            
        }
    }
</script>